import { useField } from 'formik'
import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { Form } from 'semantic-ui-react'
import Reaptcha from 'reaptcha'

interface Props {
  name: string
}

const FWOGoogleCaptcha = forwardRef((props: Props, ref) => {
  const [field, meta, helpers] = useField(props.name)
  const captcha = useRef(null)

  useImperativeHandle(ref, () => ({
    refresh() {
      captcha.current.reset()
    },
  }))

  return (
    <Form.Field
      error={
        meta.touched &&
        (field.value === null || field.value === '') &&
        !!meta.error
      }
      {...{ required: true }}
    >
      <div>
        {meta.touched &&
        (field.value != null || field.value != '') &&
        meta.error ? (
          <span className="validation-error">{meta.error}</span>
        ) : null}
        <Reaptcha
          sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
          render="explicit"
          onVerify={(response) => {
            helpers.setValue(response)
          }}
          ref={captcha}
        />
      </div>
    </Form.Field>
  )
})

FWOGoogleCaptcha.displayName = 'FWOGoogleCaptcha'
export default FWOGoogleCaptcha
